import { Flag } from 'lucide-react'
import type { NodeProps } from '@xyflow/react'
import { NodeShell } from './nodeTypes'
import type { FlowNode } from './nodeTypes'

export function EndNode({ data, selected }: NodeProps<FlowNode>) {
  return (
    <NodeShell
      icon={Flag}
      label={data.label}
      accentColor="#94a3b8"
      selected={selected}
      showSourceHandle={false}
    />
  )
}
